export default __webpack_public_path__ + "static/media/Astrana_Symbol_Plum.ca8d0aa7.svg";